import { isConsoleDeployment, isDemoDeployment } from '@/utils/deployment'
import { apiCall, consoleApiCall } from './axiosInstance'
import { authApi as demoAuthApi } from './demo/authApi'

const v3AuthApi = {
	/**
	 * Initiate login flow via redirect
	 * @param provider - OAuth provider ('google' | 'microsoft' | 'github')
	 * @param redirectUri - Relative redirect URI (must start with '/')
	 */
	initiateLogin: (provider: 'google' | 'microsoft' | 'github', redirectUri: string): void => {
		// Validate redirect URI is relative
		if (!redirectUri.startsWith('/')) {
			throw new Error('redirectUri must be a relative path starting with /')
		}

		const isConsolePortal = isConsoleDeployment()
		const locationOrigin = window.location.origin
		let loginUrl: string

		if (isConsolePortal) {
			loginUrl = `${locationOrigin}/oauth2/initiate-login?provider=${provider}&redirect_uri=${encodeURIComponent(redirectUri)}`
		} else {
			loginUrl = `${locationOrigin}/api/v3/initiate-login?provider=${provider}&redirect_uri=${encodeURIComponent(redirectUri)}`
		}

		window.location.href = loginUrl
	},

	logout: async (): Promise<void> => {
		localStorage.removeItem('auth-storage')
		sessionStorage.clear()

		try {
			if (isConsoleDeployment()) {
				await consoleApiCall('/v1/oauth2/logout', { method: 'POST' })
			} else {
				await apiCall('/v3/logout', { method: 'POST' })
			}
		} catch (error) {
			console.error('Logout error:', error)
		} finally {
			// always redirect because logout is optimistic not transactional.
			window.location.replace('/login')
		}
	},
}

export const authApi = isDemoDeployment() ? demoAuthApi : v3AuthApi
